<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} PRODUCT</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- Produit lié à une ligne XYLO-PRICING (migration 066) : le serveur refuse tout
             changement de catégorie, d'unité ou de cotes. Les champs sont grisés pour que
             personne ne tente une modification vouée au refus. -->
        <div v-if="dataLinkKey" class="mb-4 p-3 rounded" style="background:#eef6ff;border:1px solid #bcd9ff;font-size:12px">
          <b>🔗 Linked to XYLO-PRICING</b> — price grid row <code>{{ dataLinkKey }}</code>.<br>
          Category, unit and dimensions are locked and the product cannot be deleted.
          Name, volume, active state and stock alert remain editable.
        </div>
        <div class="vx-row">
        <div class="vx-col w-1/2">
        <span class="px-2" style="font-size:12px">Active?</span>
        <vs-switch color="primary" color-off="danger" v-model="dataIsActive">
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>
      </div>
          <div class="vx-col w-1/2">
            <!-- DIAMETER -->
            <span class="px-2" style="font-size:12px">Produced Externally?</span>
            <vs-switch color="primary" color-off="danger" v-model="dataExt">
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div></div>
        <!-- CATEGORY -->
        <vs-select v-model="dataCategory" @input="changeName" :disabled="!!dataLinkKey" label="Category" class="mt-5 w-full" name="category">
          <vs-select-item :key="item.id" :value="item.id"
  :text="`${item.id} - ${item.name_en}`"
            v-for="item in data_options_categories" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('category')">{{ errors.first('category') }}</span>
        <!-- SHAPE -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input label="Shape" v-model="dataShape" class="mt-5 w-full" name="shape" disabled
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('shape')">{{ errors.first('shape') }}</span>
          </div>
          <!-- UOMS -->
          <div v-if="uomLocked" class="vx-col w-1/2">
            <vs-select v-model="dataUom" @change="getOptionsUoms" label="Unit of Measure" class="mt-5 w-full" name="uom"
              disabled>
              <vs-select-item :key="item.id" :value="item.id" :text="item.name_en" v-for="item in data_options_uoms" />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('category')">{{ errors.first('category') }}</span>
          </div>
          <div v-else class="vx-col w-1/2">
            <vs-select v-model="dataUom" @change="getOptionsUoms" label="Unit of Measure" class="mt-5 w-full"
              name="uom">
              <vs-select-item :key="item.id" :value="item.id" :text="item.name_en" v-for="item in data_options_uoms" />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('category')">{{ errors.first('category') }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input label="Minimum Stock Alert" v-model="dataAlertMin" class="mt-5 w-full" name="minimum_alert"
              v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('minimum_alert')">{{ errors.first('minimum_alert') }}</span>
          </div>
        </div>
        <!-- NAME -->
        <vs-input v-if="dataShapeId === 5 || dataShapeId === 6 || dataShapeId === 8" label="Name EN"
          v-model="dataNameEN" class="mt-5 w-full" name="name_en" v-validate="'required'" />
        <vs-input v-if="dataShapeId === 5 || dataShapeId === 6 || dataShapeId === 8" label="Name FR"
          v-model="dataNameFR" class="mt-5 w-full" name="name_fr" />
        <vs-input v-if="dataShapeId === 5 || dataShapeId === 6 || dataShapeId === 8" label="Name RO"
          v-model="dataNameRO" class="mt-5 w-full" name="name_ro" />
        <vs-input v-if="dataShapeId === 5 || dataShapeId === 6 || dataShapeId === 8" label="Name ES"
          v-model="dataNameES" class="mt-5 w-full" name="name_es" />
        <vs-input v-if="dataShapeId === 5 || dataShapeId === 6 || dataShapeId === 8" label="Name DE"
          v-model="dataNameDE" class="mt-5 w-full" name="name_de" />
        <vs-input v-if="dataShapeId === 5 || dataShapeId === 6 || dataShapeId === 8" label="Name NL"
          v-model="dataNameNL" class="mt-5 w-full" />
        <vs-input v-if="dataShapeId !== 8 && dataShapeId !== 5 && dataShapeId !== 6" label="Name" v-model="dataNameEN"
          class="mt-5 w-full" name="name_en" disabled />
        <span class="text-danger text-sm" v-show="errors.has('name_en')">{{ errors.first('name_en') }}</span>
        <span class="text-danger text-sm" v-show="errors.has('name_fr')">{{ errors.first('name_fr') }}</span>
        <span class="text-danger text-sm" v-show="errors.has('name_ro')">{{ errors.first('name_ro') }}</span>
        <span class="text-danger text-sm" v-show="errors.has('name_es')">{{ errors.first('name_es') }}</span>
        <span class="text-danger text-sm" v-show="errors.has('name_de')">{{ errors.first('name_de') }}</span>
        <span class="text-danger text-sm" v-show="errors.has('name_nl')">{{ errors.first('name_nl') }}</span>
        <!-- ROULEAU -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-if="(dataShapeId === 7)" label="Roller Length (m)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataRollerLength"
              class="mt-5 w-full" name="rollerlength" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('rollerlength')">{{ errors.first('rollerlength')
              }}</span>
          </div>
          <div class="vx-col w-1/2">
            <vs-input v-if="(dataShapeId === 7)" label="Stakes Height (m)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataLength"
              class="mt-5 w-full" name="length" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('length')">{{ errors.first('length') }}</span>
          </div>
        </div>
        <!-- LENGTH -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input v-if="(dataShapeId === 1 || dataShapeId === 2 || dataShapeId === 3 || dataShapeId === 4)"
              label="Length (m)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataLength" class="mt-5 w-full" name="length"
              v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('length')">{{ errors.first('length') }}</span>
          </div>
          <div class="vx-col w-1/2">
            <!-- DIAMETER -->
            <vs-input v-if="(dataShapeId === 1)" label="Diameter (cm)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataDiameter"
              class="mt-5 w-full" name="diameter" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('diameter')">{{ errors.first('diameter') }}</span>
          </div>
        </div>
        <!-- SPACING -->
        <div class="vx-row">
          <div class="vx-col w-1/3">
            <vs-input v-if="(dataShapeId === 7)" label="Spacing Min. (cm)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataSpacing_Min"
              class="mt-5 w-full" name="spacing_min" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{ errors.first('spacing') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="(dataShapeId === 7)" label="Spacing Max. (cm)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataSpacing_Max"
              class="mt-5 w-full" name="spacing_max" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{ errors.first('spacing') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="(dataShapeId === 7)" label="Spacing Avg. (cm)" v-model="dataSpacing_Avg" class="mt-5 w-full"
              name="spacing_avg" v-validate="'decimal'" disabled />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{ errors.first('spacing') }}</span>
          </div>
        </div>
        <!-- PERIMETER -->
        <div class="vx-row">
          <div class="vx-col w-1/3">
            <vs-input v-if="(dataShapeId === 2 || dataShapeId === 3 || dataShapeId === 7)" label="Perimeter Min. (cm)"
              @input="changeName" :disabled="!!dataLinkKey" v-model="dataPerimeter_Min" class="mt-5 w-full" name="perimeter_min"
              v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('perimeter')">{{ errors.first('perimeter') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="(dataShapeId === 2 || dataShapeId === 3 || dataShapeId === 7)" label="Perimeter Max. (cm)"
              @input="changeName" :disabled="!!dataLinkKey" v-model="dataPerimeter_Max" class="mt-5 w-full" name="perimeter_max"
              v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('perimeter')">{{ errors.first('perimeter') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input v-if="(dataShapeId === 2 || dataShapeId === 3 || dataShapeId === 7)" label="Perimeter Avg. (cm)"
              v-model="dataPerimeter_Avg" class="mt-5 w-full" name="perimeter_avg" v-validate="'decimal'" disabled />
            <span class="text-danger text-sm" v-show="errors.has('perimeter')">{{ errors.first('perimeter') }}</span>
          </div>
        </div>
        <!-- Height -->
        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeId === 4" label="Height (cm)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataHeight"
              class="mt-5 w-full" name="height" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('height')">{{ errors.first('height') }}</span>
          </div>
          <!-- Width -->
          <div class="vx-col w-1/2">
            <vs-input v-if="dataShapeId === 4" label="Width (cm)" @input="changeName" :disabled="!!dataLinkKey" v-model="dataWidth"
              class="mt-5 w-full" name="width" v-validate="'decimal'" />
            <span class="text-danger text-sm" v-show="errors.has('width')">{{ errors.first('width') }}</span>
          </div>
        </div>
        <vs-input v-if="(dataShapeId === 7)" label="Radius 1 Stake (cm)" v-model="dataRadius" class="mt-5 w-full"
          name="radius" disabled />
        <span class="text-danger text-sm" v-show="errors.has('volume')">{{ errors.first('volume') }}</span>

        <vs-input v-if="(dataShapeId === 7)" label="Number of Stakes per Roller" @input="changeName(true)" :disabled="!!dataLinkKey"
          v-model="dataNbStakes" class="mt-5 w-full" name="nbstake" />
        <span class="text-danger text-sm" v-show="errors.has('nbstake')">{{ errors.first('nbstake') }}</span>

        <!-- Volume -->
        <vs-input v-if="dataShapeId === 8" label="Volume (m3)" v-model="dataVolume" class="mt-5 w-full" name="vol"
          v-validate="'decimal'" />
        <span v-if="dataShapeId === 8" class="text-danger text-sm" v-show="errors.has('vol')">{{ errors.first('vol')
          }}</span>
        <vs-input v-if="(dataShapeId === 1 || dataShapeId === 2 || dataShapeId === 3 || dataShapeId === 4 || dataShapeId === 7)"
          label="Volume (m3)" v-model="dataVolume" class="mt-5 w-full" name="volume" disabled />
        <span v-if="(dataShapeId === 1 || dataShapeId === 2 || dataShapeId === 3 || dataShapeId === 4 || dataShapeId === 7)"
          class="text-danger text-sm" v-show="errors.has('volume')">{{ errors.first('volume') }}</span>
        <!-- Audit log for this product (price/valuation changes...) when editing -->
        <audit-log-table v-if="dataId" entity="product" :id="dataId" />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="isSaveDisabled">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios.js'
import AuditLogTable from '@/components/AuditLogTable.vue'

// Ganivelles : lattes par rouleau de 5 m selon l'écartement (borne basse, cm). C'est le compte de
// l'usine (classeur « Numar de beti pe role de 5m », celui des fiches existantes) ; la formule
// L / (rayon + écartement) donnait 68 lattes au lieu de 63 en 4-5 cm, 120,47 au lieu de 116 en
// 10 m × 5-6 cm, et un volume faux d'autant. 0-1, 10-11 et 11-12 cm : comptes des fiches en place.
// Même table dans XYLO-PRICING (section-geometry.ts) : catalogue et ERP comptent le même volume.
const STAKES_PER_5M = { 0: 150, 1: 116, 2: 89, 3: 73, 4: 63, 5: 58, 6: 54, 7: 48, 8: 44, 9: 42, 10: 41, 11: 36 }

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    VuePerfectScrollbar,
    AuditLogTable
  },
  data() {
    return {
      data_options_categories: [],
      data_options_uoms: [],
      dataId: null,
      uomLocked: true,
      dataExt: false,
      dataAlertMin: '',
      dataNameEN: '',
      dataNameFR: '',
      dataNameRO: '',
      dataNameES: '',
      dataNameNL: '',
      dataNameDE: '',
      dataLength: '',
      dataRollerLength: '',
      dataRadius: '',
      dataNbStakes: '',
      dataShape: '',
      dataShapeId: '',
      dataDiameter: '',
      dataHeight: '',
      dataWidth: '',
      dataPerimeter_Min: '',
      dataPerimeter_Max: '',
      dataPerimeter_Avg: '',
      dataSpacing_Min: '',
      dataSpacing_Max: '',
      dataSpacing_Avg: '',
      dataIsActive: true,
      dataCategory: null,
      dataUom: null,
      dataVolume: '',
      dataLinkKey: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.dataId = null
        this.dataLinkKey = null
      } else {
        console.log(this.data);
        const { id, external_supplier, alert_min, name_en, name_fr, name_ro, name_es, name_de, name_nl, diameter, height, volume, width, length, radius, nbofstakes, rollerlength, spacing_min, spacing_max, spacing_avg, perimeter_min, perimeter_max, perimeter_avg, isactive, idproductcategory, iduomsreference } = JSON.parse(JSON.stringify(this.data))

        this.dataId = id,
          this.dataExt = external_supplier,
          this.dataAlertMin = alert_min,
          this.dataNameEN = name_en,
          this.dataNameFR = name_fr,
          this.dataNameRO = name_ro,
          this.dataNameES = name_es,
          this.dataNameDE = name_de,
          this.dataNameNL = name_nl,
          this.dataDiameter = diameter,
          this.dataHeight = height,
          this.dataWidth = width,
          this.dataRadius = radius,
          this.dataVolume = volume,
          this.dataLength = length / 100,
          this.dataShape = this.data.productcategory.productcategoryshape.name_en,
          this.dataShapeId = this.data.productcategory.productcategoryshape.id,
          this.dataPerimeter_Min = perimeter_min,
          this.dataPerimeter_Max = perimeter_max,
          this.dataPerimeter_Avg = perimeter_avg,
          this.dataNbStakes = nbofstakes,
          this.dataRollerLength = rollerlength,
          this.dataSpacing_Min = spacing_min,
          this.dataSpacing_Max = spacing_max,
          this.dataSpacing_Avg = spacing_avg,
          this.dataIsActive = isactive,
          this.dataCategory = idproductcategory,
          this.dataUom = iduomsreference,
          this.dataLinkKey = this.data.pricing_link_key || null,
          this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataNameEN && this.dataCategory
    },
    isSaveDisabled() {
      return !this.isFormValid
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
  },
  methods: {
    changeName(isEditingTheNbOfStake = false) {
      //this.dataNameEN = ''
      const indexCtg = this.data_options_categories.findIndex((p) => p.id === this.dataCategory)
      this.dataShape = this.data_options_categories[indexCtg].productcategoryshape.name_en
      this.dataShapeId = this.data_options_categories[indexCtg].productcategoryshape.id
      // CYLINDRE
      // this.dataAlertMin = null; // Commenté pour éviter de perdre la valeur lors des modifications
      this.dataExt = false;
      this.dataNameEN = null;
      this.dataNameFR = null;
      this.dataNameES = null;
      this.dataNameDE = null;
      this.dataNameNL = null;
      this.dataName = null;
      this.dataNameRO = null;
      this.dataVolume = null;
      /*
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        this.dataPerimeter_Min = null;
        this.dataPerimeter_Max = null;
        this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
      */
      if (this.dataShapeId === 1) {
        this.dataUom = this.data_options_uoms[0].id
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        //this.dataDiameter = null;
        this.dataPerimeter_Min = null;
        this.dataPerimeter_Max = null;
        this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        //this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        this.uomLocked = true
      }
      if (this.dataShapeId === 2) {
        this.dataUom = this.data_options_uoms[0].id
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        //this.dataPerimeter_Min = null;
        //this.dataPerimeter_Max = null;
        //this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        //this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        this.uomLocked = true
      }
      if (this.dataShapeId === 3) {
        this.dataUom = this.data_options_uoms[0].id
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        //this.dataPerimeter_Min = null;
        //this.dataPerimeter_Max = null;
        //this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        //this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        this.uomLocked = true
      }
      if (this.dataShapeId === 4) {
        this.dataUom = this.data_options_uoms[0].id
        this.dataRadius = null;
        //this.dataHeight = null;
        //this.dataWidth = null;
        this.dataDiameter = null;
        this.dataPerimeter_Min = null;
        this.dataPerimeter_Max = null;
        this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        //this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        this.uomLocked = true
      }
      if (this.dataShapeId === 5) {
        this.dataUom = this.data_options_uoms[1].id
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        this.dataPerimeter_Min = null;
        this.dataPerimeter_Max = null;
        this.dataPerimeter_Avg = null;
        this.dataVolume = 1;
        this.dataNbStakes = null;
        this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        this.uomLocked = true
      }
      if (this.dataShapeId === 6) {
        this.dataUom = this.data_options_uoms[0].id
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        this.dataPerimeter_Min = null;
        this.dataPerimeter_Max = null;
        this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        //if (!this.dataId) this.uomLocked = false
        this.uomLocked = true
      }
      if (this.dataShapeId === 7) {
        this.dataUom = this.data_options_uoms[0].id
        //this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        //this.dataPerimeter_Min = null;
        //this.dataPerimeter_Max = null;
        //this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        //this.dataNbStakes = null;
        //this.dataLength = null;
        //this.dataSpacing_Min = null;
        //this.dataSpacing_Avg = null;
        //this.dataSpacing_Max = null;
        //this.dataRollerLength = null;
        this.uomLocked = true
      }
      if (this.dataShapeId === 8) {
        this.dataUom = this.data_options_uoms[0].id
        this.dataRadius = null;
        this.dataHeight = null;
        this.dataWidth = null;
        this.dataDiameter = null;
        this.dataPerimeter_Min = null;
        this.dataPerimeter_Max = null;
        this.dataPerimeter_Avg = null;
        this.dataVolume = null;
        this.dataNbStakes = null;
        this.dataLength = null;
        this.dataSpacing_Min = null;
        this.dataSpacing_Avg = null;
        this.dataSpacing_Max = null;
        this.dataRollerLength = null;
        this.uomLocked = true
      }

      if (this.dataShapeId === 1 && this.dataLength && this.dataDiameter) {
        var diameterplusun = parseFloat(this.dataDiameter) + 1
        var diametermoinsun = this.dataDiameter - 1
        var rangediameter = diametermoinsun + '-' + diameterplusun
        this.dataNameEN = /*this.data_options_categories[indexCtg].name_en+*/"L" + this.dataLength + "m * d[" + rangediameter + "]cm"
        axios.get('/getvolume/' + this.dataShapeId + '/' + (this.dataDiameter / 2) + '/' + this.dataLength * 100)
          .then((response) => {
            this.dataVolume = response.data
          })

      }
      else if (this.dataShapeId === 2 && this.dataLength && this.dataPerimeter_Max && this.dataPerimeter_Min) {
        this.dataPerimeter_Avg = (parseFloat(this.dataPerimeter_Max) + parseFloat(this.dataPerimeter_Min)) / 2
        var rangeP = this.dataPerimeter_Min + '-' + this.dataPerimeter_Max
        this.dataNameEN = /*this.data_options_categories[indexCtg].name_en+*/"L" + this.dataLength + "m * P[" + rangeP + "]cm"

        axios.get('/getvolume/' + this.dataShapeId + '/' + this.dataPerimeter_Avg + '/' + this.dataLength * 100)
          .then((response) => {
            this.dataVolume = response.data
          })
      }
      else if (this.dataShapeId === 3 && this.dataLength && this.dataPerimeter_Max && this.dataPerimeter_Min) {
        this.dataPerimeter_Avg = (parseFloat(this.dataPerimeter_Max) + parseFloat(this.dataPerimeter_Min)) / 2
        var rangeP = this.dataPerimeter_Min + '-' + this.dataPerimeter_Max
        this.dataNameEN = /*this.data_options_categories[indexCtg].name_en+*/"L" + this.dataLength + "m * P[" + rangeP + "]cm"

        axios.get('/getvolume/' + this.dataShapeId + '/' + this.dataPerimeter_Avg + '/' + this.dataLength * 100)
          .then((response) => {
            this.dataVolume = response.data
          })
      }
      else if (this.dataShapeId === 4 && this.dataLength && this.dataWidth && this.dataHeight) {
        this.dataNameEN = /*this.data_options_categories[indexCtg].name_en+*/"L" + this.dataLength + "m * W" + this.dataWidth + "cm *  H" + this.dataHeight + "cm"
        axios.get('/getvolume/' + this.dataShapeId + '/' + this.dataLength * 100 + '/' + this.dataWidth + '/' + this.dataHeight)
          .then((response) => {
            this.dataVolume = response.data
          })
      }
      else if (this.dataShapeId === 7 && this.dataLength && this.dataPerimeter_Max && this.dataPerimeter_Min && this.dataSpacing_Min && this.dataSpacing_Max && this.dataRollerLength) {
        this.dataPerimeter_Avg = (parseFloat(this.dataPerimeter_Max) + parseFloat(this.dataPerimeter_Min)) / 2
        this.dataSpacing_Avg = (parseFloat(this.dataSpacing_Max) + parseFloat(this.dataSpacing_Min)) / 2
        axios.get('/getvolume/77/' + this.dataPerimeter_Avg + '/' + this.dataLength * 100)
          .then((response) => {
            this.dataRadius = response.data
            if (isEditingTheNbOfStake != true) {
              const band = parseFloat(this.dataSpacing_Max) - parseFloat(this.dataSpacing_Min) === 1
              const perFive = band ? STAKES_PER_5M[parseFloat(this.dataSpacing_Min)] : null
              this.dataNbStakes = perFive
                ? (perFive * this.dataRollerLength) / 5
                : (this.dataRollerLength * 100) / (this.dataRadius + this.dataSpacing_Avg)
            }
          })
          .then((rs) => {
            axios.get('/getvolume/3/' + this.dataPerimeter_Avg + '/' + this.dataLength * 100)
              .then((response) => {
                if (this.dataNbStakes != null) {
                  this.dataVolume = (response.data) * this.dataNbStakes
                  var rangeP = this.dataPerimeter_Min + '-' + this.dataPerimeter_Max
                  this.dataNameEN = "L" + this.dataRollerLength + "m * H" + this.dataLength + "m Spacing:" + this.dataSpacing_Avg + "cm (" + parseFloat(this.dataNbStakes).toFixed(0) + " * P[" + rangeP + "]cm)"
                }
                else this.dataNameEN = null
              })
          })
      }
    },
    async getOptionsCategories() {
      axios.get('/productcategory/active/data')
        .then((response) => {
          this.data_options_categories = [...response.data]
        })
    },
    async getOptionsUoms() {
      axios.get('/product/uoms/data')
        .then((response) => {
          this.data_options_uoms = [...response.data]
        })
    },
    initValues() {
      if (this.data.id) return
      this.dataNameEN = '',
        this.dataNameFR = '',
        this.dataNameES = '',
        this.dataNameRO = '',
        this.dataNameDE = '',
        this.dataNameNL = '',
        this.dataRadius = null,
        this.dataPerimeter_Min = null,
        this.dataPerimeter_Max = null,
        this.dataPerimeter_Avg = null,
        this.dataDiameter = null,
        this.dataLength = null,
        this.dataWidth = null,
        this.dataHeight = null,
        this.dataIsActive = true,
        this.dataVolume = null
        //this.dataUom = null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var longueur = null
          if (this.dataLength > 0) {
            longueur = this.dataLength * 100
          }
          else {
            longueur = null
          }
          let obj = {}
          if (this.dataShapeId == 5 || this.dataShapeId == 6 || this.dataShapeId == 8) {
            obj = {
              id: this.dataId,
              alert_min: this.dataAlertMin || null,
              external_supplier : this.dataExt,
              name_en: this.dataNameEN,
              name_fr: this.dataNameFR,
              name_ro: this.dataNameRO,
              name_de: this.dataNameDE,
              name_es: this.dataNameES,
              name_nl: this.dataNameNL,
              height: this.dataHeight,
              width: this.dataWidth,
              radius: this.dataRadius,
              diameter: this.dataDiameter,
              length: longueur,
              isactive: this.dataIsActive,
              volume: this.dataVolume,
              perimeter_min: this.dataPerimeter_Min,
              perimeter_max: this.dataPerimeter_Max,
              perimeter_avg: this.dataPerimeter_Avg,
              idproductcategory: this.dataCategory,
              iduomsreference: this.dataUom,
            }
          }
          else {
            obj = {
              id: this.dataId,
              alert_min: this.dataAlertMin || null,
              external_supplier : this.dataExt,
              name_en: this.dataNameEN,
              name_fr: this.dataNameEN,
              name_ro: this.dataNameEN,
              name_de: this.dataNameEN,
              name_es: this.dataNameEN,
              name_nl: this.dataNameEN,
              height: this.dataHeight,
              width: this.dataWidth,
              radius: this.dataRadius,
              diameter: this.dataDiameter,
              length: longueur,
              isactive: this.dataIsActive,
              volume: this.dataVolume,
              perimeter_min: this.dataPerimeter_Min,
              perimeter_max: this.dataPerimeter_Max,
              perimeter_avg: this.dataPerimeter_Avg,
              spacing_min: this.dataSpacing_Min,
              spacing_max: this.dataSpacing_Max,
              spacing_avg: this.dataSpacing_Avg,
              nbofstakes: this.dataNbStakes,
              rollerlength: this.dataRollerLength,
              idproductcategory: this.dataCategory,
              iduomsreference: this.dataUom,
            }
          }
          if (this.dataId !== null && this.dataId >= 0) {
            // Le succès s'annonçait AVANT la réponse du serveur, donc même quand il refusait
            // (produit lié à XYLO-PRICING, 409). On attend désormais la réponse.
            this.$store.dispatch('dataListProduct/updateItem', obj)
              .then(() => this.$vs.notify({
                color: 'success',
                title: 'Product Updated!',
                text: 'The Product was successfully edited'
              }))
              .catch(err => {
                console.error(err)
                this.$vs.notify({
                  color: 'danger',
                  title: 'Product not updated',
                  text: (err && err.response && err.response.data && err.response.data.message) || 'The server refused the change.',
                  time: 10000
                })
              })
          }
          else {
            delete obj.id
            this.$store.dispatch('dataListProduct/createItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({
              color: 'success',
              title: 'Product Created!',
              text: 'The Product was successfully added'
            })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  },
  created() {
    this.getOptionsCategories();
    this.getOptionsUoms();
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
